import { motion } from "framer-motion";
import { FIRST_HUNDRED_POINTS } from "../content";

export default function FirstHundred() {
  return (
    <section data-testid="first-hundred-section" className="py-28 md:py-36 px-4 sm:px-6 border-t border-border bg-secondary/20">
      <div className="max-w-4xl mx-auto">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="font-mono text-xs tracking-[0.35em] text-gold mb-6"
        >
          04 — WHAT WE'RE DOING
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="font-serif text-3xl sm:text-4xl md:text-5xl font-light tracking-tight mb-16"
        >
          The first 100 <span className="italic text-gold">build it with us.</span>
        </motion.h2>

        <div>
          {FIRST_HUNDRED_POINTS.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="grid sm:grid-cols-[70px_1fr] gap-3 sm:gap-10 py-8 border-t border-border"
              data-testid={`first-hundred-point-${i}`}
            >
              <span className="font-mono text-sm text-gold tracking-[0.2em] pt-1">{String(i + 1).padStart(2, "0")}</span>
              <div>
                <h3 className="font-serif text-xl sm:text-2xl font-light mb-2">{p.title}</h3>
                <p className="text-muted-foreground leading-relaxed max-w-xl">{p.body}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="mt-10 pt-8 border-t border-border font-mono text-xs tracking-[0.25em] text-gold"
          data-testid="free-seats-line"
        >
          FOUNDING SEATS ARE FREE. NO PAYMENT, NO CARD.
        </motion.p>
      </div>
    </section>
  );
}
